module.exports = __webpack_public_path__ + "static/media/Biomes_card_bg_03.a9090e86.jpg";